export const structure = JSON.parse(`{
    "sports": [
        {
            "id": "GNFB17MNF4TH4KM",
            "names": {
                "abbreviation": "FBL",
                "default": "Fútbol"
            }
        }
    ],
    "leagues": [
        {
            "id": "GNA5MGHG2ZVX2RD",
            "names": {
                "full": "Campeonato del Mundo",
                "default": "Campeonato del Mundo",
                "short": "World Cup",
                "nick": "FIFA World Cup"
            },
            "images": {
                "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/competition/logo/large/8.png"
            },
            "dateAndTimeInfo": {},
            "state": {},
            "status": {},
            "sportId": "GNFB17MNF4TH4KM",
            "xids": [
                {
                    "supplier": "infostrada",
                    "type": "soccer_competitionevent",
                    "id": "8"
                }
            ]
        }
    ],
    "leagueSeasons": [
        {
            "id": "GN1HX6DXNM8Q39W",
            "names": {
                "default": "2022"
            },
            "images": {
                "logo": "https://gsd-image-store.sports.gracenote.com/602E8F042F463DC47EBFDF6A94ED5A6D2644436514742553.png"
            },
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-20",
                "endDateLocal": "2022-12-18"
            },
            "state": {},
            "status": {},
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-20T16:00:00.000Z",
                    "timeTo": "2022-11-20T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-21T13:00:00.000Z",
                    "timeTo": "2022-11-21T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-22T10:00:00.000Z",
                    "timeTo": "2022-11-22T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-23T10:00:00.000Z",
                    "timeTo": "2022-11-23T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-24T10:00:00.000Z",
                    "timeTo": "2022-11-24T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-25T10:00:00.000Z",
                    "timeTo": "2022-11-25T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-26T10:00:00.000Z",
                    "timeTo": "2022-11-26T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-27T10:00:00.000Z",
                    "timeTo": "2022-11-27T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-28T10:00:00.000Z",
                    "timeTo": "2022-11-28T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-29T15:00:00.000Z",
                    "timeTo": "2022-11-29T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-30T15:00:00.000Z",
                    "timeTo": "2022-11-30T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-01T15:00:00.000Z",
                    "timeTo": "2022-12-01T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-02T15:00:00.000Z",
                    "timeTo": "2022-12-02T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-03T15:00:00.000Z",
                    "timeTo": "2022-12-03T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-04T15:00:00.000Z",
                    "timeTo": "2022-12-04T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-05T15:00:00.000Z",
                    "timeTo": "2022-12-05T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-06T15:00:00.000Z",
                    "timeTo": "2022-12-06T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-09T15:00:00.000Z",
                    "timeTo": "2022-12-09T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-10T15:00:00.000Z",
                    "timeTo": "2022-12-10T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-13T19:00:00.000Z",
                    "timeTo": "2022-12-13T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-14T19:00:00.000Z",
                    "timeTo": "2022-12-14T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-17T15:00:00.000Z",
                    "timeTo": "2022-12-17T15:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-18T15:00:00.000Z",
                    "timeTo": "2022-12-18T15:00:00.000Z"
                }
            ]
        }
    ],
    "overalls": [],
    "phases": [
        {
            "id": "GN0RDNSRNFX8CN5",
            "names": {
                "short": "PO 3/4",
                "default": "3er puesto"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-17",
                "endDateLocal": "2022-12-17"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_ROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-17T15:00:00.000Z",
                    "timeTo": "2022-12-17T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNDS14ZN19MA8AE",
            "names": {
                "short": "CF",
                "default": "Cuartos de Final"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-09",
                "endDateLocal": "2022-12-10"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_ROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-09T15:00:00.000Z",
                    "timeTo": "2022-12-09T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-10T15:00:00.000Z",
                    "timeTo": "2022-12-10T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNBHVT79GEK8PDY",
            "names": {
                "default": "Semifinal",
                "short": "SF"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-13",
                "endDateLocal": "2022-12-14"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_ROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-13T19:00:00.000Z",
                    "timeTo": "2022-12-13T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-14T19:00:00.000Z",
                    "timeTo": "2022-12-14T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNFMX613A54R1CW",
            "names": {
                "default": "Grupo E",
                "short": "E"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-23",
                "endDateLocal": "2022-12-01"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-23T13:00:00.000Z",
                    "timeTo": "2022-11-23T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-27T10:00:00.000Z",
                    "timeTo": "2022-11-27T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-01T19:00:00.000Z",
                    "timeTo": "2022-12-01T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNBAN17DY17C6HC",
            "names": {
                "default": "Grupo A",
                "short": "A"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-20",
                "endDateLocal": "2022-11-29"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-20T16:00:00.000Z",
                    "timeTo": "2022-11-20T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-21T16:00:00.000Z",
                    "timeTo": "2022-11-21T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-25T13:00:00.000Z",
                    "timeTo": "2022-11-25T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-29T15:00:00.000Z",
                    "timeTo": "2022-11-29T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN5H41S89V75M3R",
            "names": {
                "default": "Grupo D",
                "short": "D"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-22",
                "endDateLocal": "2022-11-30"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-22T13:00:00.000Z",
                    "timeTo": "2022-11-22T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-26T10:00:00.000Z",
                    "timeTo": "2022-11-26T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-30T15:00:00.000Z",
                    "timeTo": "2022-11-30T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN6XTMAXA112QVK",
            "names": {
                "default": "Grupo C",
                "short": "C"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-22",
                "endDateLocal": "2022-11-30"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-22T10:00:00.000Z",
                    "timeTo": "2022-11-22T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-26T13:00:00.000Z",
                    "timeTo": "2022-11-26T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-30T19:00:00.000Z",
                    "timeTo": "2022-11-30T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNFP1FYJ0XFHG2K",
            "names": {
                "short": "B",
                "default": "Grupo B"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-21",
                "endDateLocal": "2022-11-29"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-21T13:00:00.000Z",
                    "timeTo": "2022-11-21T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-25T10:00:00.000Z",
                    "timeTo": "2022-11-25T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-29T19:00:00.000Z",
                    "timeTo": "2022-11-29T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNAQVRWVJVGM77G",
            "names": {
                "default": "Grupo F",
                "short": "F"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-23",
                "endDateLocal": "2022-12-01"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-23T10:00:00.000Z",
                    "timeTo": "2022-11-23T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-27T13:00:00.000Z",
                    "timeTo": "2022-11-27T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-01T15:00:00.000Z",
                    "timeTo": "2022-12-01T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN0VS7X9CKVQ2BK",
            "names": {
                "default": "Grupo G",
                "short": "G"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-24",
                "endDateLocal": "2022-12-02"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-24T10:00:00.000Z",
                    "timeTo": "2022-11-24T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-28T10:00:00.000Z",
                    "timeTo": "2022-11-28T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-02T19:00:00.000Z",
                    "timeTo": "2022-12-02T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNDE9A5NB8NEE9C",
            "names": {
                "short": "H",
                "default": "Grupo H"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-24",
                "endDateLocal": "2022-12-02"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_GROUP",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-24T13:00:00.000Z",
                    "timeTo": "2022-11-24T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-28T13:00:00.000Z",
                    "timeTo": "2022-11-28T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-02T15:00:00.000Z",
                    "timeTo": "2022-12-02T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNFPAYWC9M394J5",
            "names": {
                "default": "Octavos de Final",
                "short": "Ult16"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-03",
                "endDateLocal": "2022-12-06"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_ROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-03T15:00:00.000Z",
                    "timeTo": "2022-12-03T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-04T15:00:00.000Z",
                    "timeTo": "2022-12-04T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-05T15:00:00.000Z",
                    "timeTo": "2022-12-05T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-06T15:00:00.000Z",
                    "timeTo": "2022-12-06T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNFEPTP0PBTFA68",
            "names": {
                "short": "F",
                "default": "Final"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-18",
                "endDateLocal": "2022-12-18"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_ROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-18T15:00:00.000Z",
                    "timeTo": "2022-12-18T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN8N2CJNFGC0M4G",
            "names": {
                "short": "Fas grup",
                "default": "Fase de Grupos"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-20",
                "endDateLocal": "2022-12-02"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_ROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-20T16:00:00.000Z",
                    "timeTo": "2022-11-20T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-21T13:00:00.000Z",
                    "timeTo": "2022-11-21T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-22T10:00:00.000Z",
                    "timeTo": "2022-11-22T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-23T10:00:00.000Z",
                    "timeTo": "2022-11-23T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-24T10:00:00.000Z",
                    "timeTo": "2022-11-24T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-25T10:00:00.000Z",
                    "timeTo": "2022-11-25T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-26T10:00:00.000Z",
                    "timeTo": "2022-11-26T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-27T10:00:00.000Z",
                    "timeTo": "2022-11-27T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-28T10:00:00.000Z",
                    "timeTo": "2022-11-28T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-29T15:00:00.000Z",
                    "timeTo": "2022-11-29T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-30T15:00:00.000Z",
                    "timeTo": "2022-11-30T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-01T15:00:00.000Z",
                    "timeTo": "2022-12-01T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-02T15:00:00.000Z",
                    "timeTo": "2022-12-02T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN03HWNER5MEW45",
            "names": {
                "short": "3a Jor",
                "default": "3a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-29"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-29T15:00:00.000Z",
                    "timeTo": "2022-11-29T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-30T15:00:00.000Z",
                    "timeTo": "2022-11-30T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-01T15:00:00.000Z",
                    "timeTo": "2022-12-01T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-02T15:00:00.000Z",
                    "timeTo": "2022-12-02T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNFH226FFNRYRYC",
            "names": {
                "short": "1a Jor",
                "default": "1a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-09"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNDS14ZN19MA8AE",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-09T15:00:00.000Z",
                    "timeTo": "2022-12-09T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-10T15:00:00.000Z",
                    "timeTo": "2022-12-10T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN2TACB00XHVX4W",
            "names": {
                "short": "1a Jor",
                "default": "1a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-20"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-20T16:00:00.000Z",
                    "timeTo": "2022-11-20T16:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-21T13:00:00.000Z",
                    "timeTo": "2022-11-21T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-22T10:00:00.000Z",
                    "timeTo": "2022-11-22T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-23T10:00:00.000Z",
                    "timeTo": "2022-11-23T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-24T10:00:00.000Z",
                    "timeTo": "2022-11-24T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN492TFBG7DATDF",
            "names": {
                "short": "2a Jor",
                "default": "2a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-11-25"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN8N2CJNFGC0M4G",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-11-25T10:00:00.000Z",
                    "timeTo": "2022-11-25T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-26T10:00:00.000Z",
                    "timeTo": "2022-11-26T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-27T10:00:00.000Z",
                    "timeTo": "2022-11-27T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-11-28T10:00:00.000Z",
                    "timeTo": "2022-11-28T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN01S52Z1EXD5GY",
            "names": {
                "short": "1a Jor",
                "default": "1a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-03"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-03T15:00:00.000Z",
                    "timeTo": "2022-12-03T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-04T15:00:00.000Z",
                    "timeTo": "2022-12-04T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-05T15:00:00.000Z",
                    "timeTo": "2022-12-05T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-06T15:00:00.000Z",
                    "timeTo": "2022-12-06T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN3M1N0DVD6YZCM",
            "names": {
                "short": "1a Jor",
                "default": "1a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-17"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN0RDNSRNFX8CN5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-17T15:00:00.000Z",
                    "timeTo": "2022-12-17T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNE7V0DCREYDG41",
            "names": {
                "short": "1a Jor",
                "default": "1a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-13"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNBHVT79GEK8PDY",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-13T19:00:00.000Z",
                    "timeTo": "2022-12-13T19:00:00.000Z"
                },
                {
                    "timeFrom": "2022-12-14T19:00:00.000Z",
                    "timeTo": "2022-12-14T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNBG2X47EWJ2V64",
            "names": {
                "short": "1a Jor",
                "default": "1a Jornada"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-18"
            },
            "state": {},
            "status": {},
            "typeDetail": "PHASE_MATCHROUND",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFEPTP0PBTFA68",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-18T15:00:00.000Z",
                    "timeTo": "2022-12-18T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN019T952GC6WXG",
            "names": {
                "default": "Pairing 2"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-03",
                "endDateLocal": "2022-12-03"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-03T19:00:00.000Z",
                    "timeTo": "2022-12-03T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNF8A9RVRRKAB1Q",
            "names": {
                "default": "Pairing 2"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-09",
                "endDateLocal": "2022-12-09"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNDS14ZN19MA8AE",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-09T15:00:00.000Z",
                    "timeTo": "2022-12-09T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN77A16MN4HGGCX",
            "names": {
                "default": "Pairing 7"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-06",
                "endDateLocal": "2022-12-06"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-06T15:00:00.000Z",
                    "timeTo": "2022-12-06T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNFCTC59F8F010W",
            "names": {
                "default": "Pairing 5"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-04",
                "endDateLocal": "2022-12-04"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-04T19:00:00.000Z",
                    "timeTo": "2022-12-04T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN842PMS8HNJNNQ",
            "names": {
                "default": "Pairing 1"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-18",
                "endDateLocal": "2022-12-18"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFEPTP0PBTFA68",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-18T15:00:00.000Z",
                    "timeTo": "2022-12-18T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNE96G2MZTJEBE2",
            "names": {
                "default": "Pairing 2"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-14",
                "endDateLocal": "2022-12-14"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNBHVT79GEK8PDY",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-14T19:00:00.000Z",
                    "timeTo": "2022-12-14T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN4AXKFNYT9JYEW",
            "names": {
                "default": "Pairing 4"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-05",
                "endDateLocal": "2022-12-05"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-05T19:00:00.000Z",
                    "timeTo": "2022-12-05T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN62KAZ8R1919T6",
            "names": {
                "default": "Pairing 3"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-05",
                "endDateLocal": "2022-12-05"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-05T15:00:00.000Z",
                    "timeTo": "2022-12-05T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN4F6F0V7HAJEWR",
            "names": {
                "default": "Pairing 1"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-09",
                "endDateLocal": "2022-12-09"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNDS14ZN19MA8AE",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-09T19:00:00.000Z",
                    "timeTo": "2022-12-09T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNC1P7DC82NZ8PK",
            "names": {
                "default": "Pairing 4"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-10",
                "endDateLocal": "2022-12-10"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNDS14ZN19MA8AE",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-10T15:00:00.000Z",
                    "timeTo": "2022-12-10T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN5XP94JJT0SQ4N",
            "names": {
                "default": "Pairing 3"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-10",
                "endDateLocal": "2022-12-10"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNDS14ZN19MA8AE",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-10T19:00:00.000Z",
                    "timeTo": "2022-12-10T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN96M9HTQMJXKTY",
            "names": {
                "default": "Pairing 1"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-13",
                "endDateLocal": "2022-12-13"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNBHVT79GEK8PDY",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-13T19:00:00.000Z",
                    "timeTo": "2022-12-13T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN9SA4RASDQAKR2",
            "names": {
                "default": "Pairing 8"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-06",
                "endDateLocal": "2022-12-06"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-06T19:00:00.000Z",
                    "timeTo": "2022-12-06T19:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN6TSC98P5RKGBP",
            "names": {
                "default": "Pairing 1"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-03",
                "endDateLocal": "2022-12-03"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-03T15:00:00.000Z",
                    "timeTo": "2022-12-03T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GN43S1NW6HPW5RS",
            "names": {
                "default": "Pairing 6"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-04",
                "endDateLocal": "2022-12-04"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GNFPAYWC9M394J5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-04T15:00:00.000Z",
                    "timeTo": "2022-12-04T15:00:00.000Z"
                }
            ]
        },
        {
            "id": "GNFYGDWZ8WHN94Y",
            "names": {
                "default": "Pairing 1"
            },
            "images": {},
            "dateAndTimeInfo": {
                "startDateLocal": "2022-12-17",
                "endDateLocal": "2022-12-17"
            },
            "state": {},
            "status": {
                "scheduleStatus": "SCHEDULED"
            },
            "typeDetail": "PHASE_PAIR",
            "sportId": "GNFB17MNF4TH4KM",
            "relatedSportsEvents": [
                {
                    "id": "GNA5MGHG2ZVX2RD",
                    "type": "LEAGUE"
                },
                {
                    "id": "GN1HX6DXNM8Q39W",
                    "type": "LEAGUE_SEASON"
                },
                {
                    "id": "GN0RDNSRNFX8CN5",
                    "type": "PHASE",
                    "typeDetail": "PHASE_ROUND",
                    "depth": 1,
                    "navigationInfo": {
                        "isKnockout": true
                    }
                }
            ],
            "matchScheduledStartSegments": [
                {
                    "timeFrom": "2022-12-17T15:00:00.000Z",
                    "timeTo": "2022-12-17T15:00:00.000Z"
                }
            ]
        }
    ]
}`);


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/structure.ts